import { graphql, HttpResponse } from 'msw'
import {
  AchAccountType,
  type CustomerDetails,
  EmploymentStatus,
  EnrollmentInvestmentExperienceCategory,
  EnrollmentInvestmentObjectiveCategory,
  EnrollmentTaxFilingStatusType,
  LinkedAccountStatus,
  LinkedInstitutionStatus,
  MaritalStatus,
  Occupation,
  PersonalNetWorthRange,
} from '../../models'

export const customerDetailsMock: CustomerDetails = {
  customer: {
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    address: {
      line1: '120 Oak Str',
      line2: '',
      city: 'New York',
      region: 'NY',
      postalCode: '10001',
      country: 'US',
    },
    phone: {
      countryPhoneCode: 1,
      phoneNumber: '8001234567',
    },
    email: 'john.doe@gmail.com',
    linkedAccounts: {
      achAccounts: [
        // Expired Account should not be shown in the transfer page, but should be shown in the external accounts page
        {
          __typename: 'LinkedAchAccount',
          alias: 0,
          name: 'Chase Checking',
          mask: 'x-1234',
          linkedAccountStatus: LinkedAccountStatus.EXPIRED,
          institutionName: 'JP Morgan Chase Bank',
          identifier: 'asas-23rf-fdsf-1234',
          achType: AchAccountType.CHECKING,
        },
      ],
      isSingleRestricted: false,
    },
    externalAccounts: {
      institutions: [
        {
          __typename: 'LinkedExternalInstitution',
          institutionName: 'Chase',
          institutionId: 'ins_56',
          linkedInstitutionStatus: LinkedInstitutionStatus.ACTIVE,
          accounts: [
            {
              __typename: 'LinkedExternalAccount',
              alias: 1001,
              name: 'Chase Total Checking',
              externalBalance: {
                balance: 65000,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
            {
              __typename: 'LinkedExternalAccount',
              alias: 1002,
              name: 'Chase Premier Savings',
              externalBalance: {
                balance: 45000,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
          ],
        },
        {
          __typename: 'LinkedExternalInstitution',
          institutionName: 'Fidelity Investments',
          institutionId: 'ins_68',
          linkedInstitutionStatus: LinkedInstitutionStatus.EXPIRED,
          accounts: [
            {
              __typename: 'LinkedExternalAccount',
              alias: 2001,
              name: 'Fidelity Brokerage Account',
              externalBalance: {
                balance: 25000,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
            {
              __typename: 'LinkedExternalAccount',
              alias: 2002,
              name: 'Fidelity Roth IRA',
              externalBalance: {
                balance: 30000,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
            {
              __typename: 'LinkedExternalAccount',
              alias: 2003,
              name: 'Fidelity Cash Management',
              externalBalance: {
                balance: 15123,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
          ],
        },
        {
          __typename: 'LinkedExternalInstitution',
          institutionName: 'Charles Schwab',
          institutionId: 'ins_10',
          linkedInstitutionStatus: LinkedInstitutionStatus.ACTIVE,
          accounts: [
            {
              __typename: 'LinkedExternalAccount',
              alias: 3001,
              name: 'Schwab Investor Checking',
              externalBalance: {
                balance: 27203,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
            {
              __typename: 'LinkedExternalAccount',
              alias: 3002,
              name: 'Schwab Brokerage',
              externalBalance: {
                balance: 574001.25,
                currencyCode: 'USD',
                lastUpdated: new Date('2024-02-04').toISOString(),
              },
            },
          ],
        },
      ],
      // accounts: [
      //   {
      //     __typename: 'LinkedExternalAccount',
      //     alias: 10,
      //     name: 'Checking',
      //     linkedAccountStatus: LinkedAccountStatus.ACTIVE,
      //     institutionId: '1234',
      //     institutionName: 'Charles Schwab',
      //     externalBalance: {
      //       balance: 9000,
      //       available: 8500,
      //       current: 9000,
      //       limit: 10000,
      //       currencyCode: 'USD',
      //       lastUpdated: new Date('2024-02-04').toISOString(),
      //     },
      //   },
      //   {
      //     __typename: 'LinkedExternalAccount',
      //     alias: 11,
      //     name: 'Charles Joint Checking',
      //     linkedAccountStatus: LinkedAccountStatus.VERIFYING,
      //     institutionId: '1234',
      //     institutionName: 'Charles Schwab',
      //     externalBalance: {
      //       balance: 80200,
      //       available: 75000,
      //       current: 80200,
      //       limit: 85000,
      //       currencyCode: 'USD',
      //       lastUpdated: new Date('2024-08-02').toISOString(),
      //     },
      //   },
      //   {
      //     __typename: 'LinkedExternalAccount',
      //     alias: 12,
      //     name: 'Chase Primary Checking',
      //     linkedAccountStatus: LinkedAccountStatus.EXPIRING_SOON,
      //     institutionId: '2341',
      //     institutionName: 'Chase',
      //     // externalBalance: {
      //     //   balance: 15000,
      //     //   available: 14800,
      //     //   current: 15000,
      //     //   limit: 20000,
      //     //   currencyCode: 'USD',
      //     //   lastUpdated: new Date('2024-01-01').toISOString(),
      //     // },
      //   },
      // ],
    },
    ssnLastFour: '1234',
    birthDate: '1980-01-01',
    tags: ['LA'],
    attributes: {
      firstDeposit: false,
    },
    maritalStatus: MaritalStatus.MARRIED,
    lastLogin: '2024-11-02T22:15:39.523Z',
    createdDate: '2024-10-16',
    employmentStatus: EmploymentStatus.EMPLOYED,
    occupation: Occupation.TECHNOLOGY_IT,
    personalAnnualGrossIncome: 100000,
    personalNetWorthRange: PersonalNetWorthRange.BETWEEN_500K_AND_1M,
    isBrokerDealer: false,
    isDirectorPolicyMakerOfCompany: false,
    taxFilingStatus: EnrollmentTaxFilingStatusType.MARRIED_FILING_JOINTLY,
    investmentObjective: EnrollmentInvestmentObjectiveCategory.GENERATE_INCOME,
    investmentExperience: EnrollmentInvestmentExperienceCategory.MODERATE,
    isPoliticallyExposedPerson: true,
    affiliatedPoliticalOrganizations: ['TESLA'],
    hasPoliticallyExposedImmediateFamilyMembers: true,
    politicallyExposedImmediateFamilyMembers: ['Elon Musk'],
  },
  customerService: {
    tokens: {
      helpCenterToken: 'sdfnnfeufbwefnalsdfl',
      inAppChatToken: 'afssdfUFsdfjsdfdf87sdfsdk',
    },
  },
}

export const mockGetCustomerDetailsHandler = graphql.query('customerDetails', () => {
  return HttpResponse.json({ data: customerDetailsMock })
})

export const mockCustomer = [mockGetCustomerDetailsHandler]
